import React from "react";
import AppV2Shell from "./v2/AppV2Shell";

const AppEntry = () => <AppV2Shell />;

export default AppEntry;
